const getFull = person => {
  const first = person.get('first_name') || ''
  const last = person.get('last_name') || ''
  const full = `${first} ${last}`.trim().replace(/\s+/, ' ')

  return full
}

export default getFull
